import React, { useEffect } from 'react'
import { useSlaStore } from '../../store/Paramettre/slaStore'
import { SLAConfig } from './SLAConfigs'

export const SLA = () => {

    const sla = useSlaStore()
    useEffect(() => {
        sla.getData()
    }, [])

    const slaIndicators = [
        {
            id: 1,
            description: 'Délai de connexion du client',
            param: 'DELAI_CONNEXION_DU_CLIENT',
            defaultValue: sla?.data?.find(e => e.indicateur === 'DELAI_CONNEXION_DU_CLIENT')?.valeur,
            message: 'Délai de connexion du client appliqué',
            periode: sla?.data?.find(e => e.indicateur === 'DELAI_CONNEXION_DU_CLIENT')?.periode,
        }
    ]


    return (
        <div>
            {
                slaIndicators.map((item) => (
                    <SLAConfig key={item.id}
                        description={item.description}
                        message={item.message}
                        defaultValue={item.defaultValue}
                        param={item.param}
                        periode={item.periode}
                    />

                ))
            }
        </div>
    )
}
